<template>
  <b-navbar :class="classObject" :type="$props.type" toggleable>
    <div :class="containerClasses">
      <slot name="brand"></slot>

      <b-collapse
        is-nav
        id="nav-text-collapse"
        class="navbar-custom-collapse collapse show"
        :class="$props.menuClasses"
        :visible="$props.show"
        v-click-outside="handleCloseMenu"
      >
        <slot :close-menu="handleCloseMenu"></slot>
      </b-collapse>

      <slot name="non-collapse"></slot>

      <slot name="toggle-button">
        <b-navbar-toggle
          target="nav-text-collapse"
          @click.stop="handleToggleMenu"
        >
        </b-navbar-toggle>
      </slot>
    </div>
  </b-navbar>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'

export default defineComponent({
  name: 'BaseNav',
  props: {
    show: {
      type: Boolean,
      default: false,
      description:
        'Whether navbar menu is shown (valid for viewports < specified by `expand` prop)'
    },
    transparent: {
      type: Boolean,
      default: false,
      description: 'Whether navbar is transparent'
    },
    expand: {
      type: String,
      default: 'lg',
      description: 'Breakpoint where nav should expand'
    },
    menuClasses: {
      type: [String, Object, Array],
      default: '',
      description:
        'Navbar menu (items) classes. Can be used to align menu items to the right/left'
    },
    containerClasses: {
      type: [String, Object, Array],
      default: 'container',
      description:
        'Container classes. Can be used to control container classes (contains both navbar brand and menu items)'
    },
    type: {
      type: String,
      default: '',
      validator(value) {
        return [
          '',
          'dark',
          'success',
          'danger',
          'warning',
          'white',
          'primary',
          'light',
          'info',
          'vue'
        ].includes(value)
      },
      description: 'Navbar color type'
    }
  },
  emits: ['change'],
  setup(props, { emit }) {
    const classObject = computed(() => {
      const classes = [
        { 'navbar-transparent': props.transparent },
        { [`navbar-expand-${props.expand}`]: props.expand }
      ]

      if (!!props.position) {
        classes.push(`navbar-${props.position}`)
      }

      if (!props.transparent) {
        classes.push(`bg-${props.type}`)
      }

      return classes
    })

    const handleToggleMenu = () => {
      emit('change', !props.show)
    }

    const handleCloseMenu = () => {
      emit('change', false)
    }

    return {
      classObject,

      handleToggleMenu,
      handleCloseMenu
    }
  }
})
</script>
